 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		91: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		91: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"Debug","42":"EMAPortal","43":"EarlyProtect360Plus","44":"EarlyProtect360Plus.Dashboard","45":"EarlyProtect360Plus.Details","46":"FamilyProtect360","47":"FamilyProtectLiteWithUpgrade","48":"FilipinoBond","49":"FlashPayShieldWithUpgrade","50":"FraudProtect360","51":"HIProtect360Protect360","52":"HomeProtect360","53":"HomeProtectLite","54":"HomeSafe","55":"HomeStarterKit","56":"InternalDemoCookie","57":"KeymanProtect360","58":"KeymanProtect360.Dashboard","59":"KeymanProtect360.Details","60":"LeadForm","61":"Loan Protect 360 Renewal","62":"LoanProtect360","63":"LoanProtect360.Dashboard","64":"LoanProtect360.Details","65":"MaidProtect360","66":"MotoringCardShieldWithUpgrade","67":"Motorshow2020","68":"PartnerProgram","69":"PhoneProtect360","70":"PowerAgentPortal","71":"Prestige","72":"Prestige.Secured","73":"PublicHousingAssured","74":"ReviewUs","75":"SBSTPAProtectLite","76":"SBSTPAProtectPlus","77":"SBSTTravelInsurance","78":"SOA","79":"SimplyGo","80":"SingaporeTravelPass","81":"Touristcard","82":"TravelAssured","83":"TravelAssuredPlus","84":"TravelProtect360","85":"TravelProtect360Plus","86":"cileadform","87":"currencyconverter","88":"freehomeinsurance","90":"motorshow","92":"transferprotect360pro","93":"vCashCard","94":"weather"}[chunkId]||chunkId) + "." + {"0":"261fe484","1":"7ec749cd","2":"57056009","3":"9eb2038b","4":"3993626c","5":"95297c0f","6":"d0155bbe","7":"b878f7ad","8":"16a1b2db","9":"d6272b78","10":"6a33d3c0","11":"7526aa0e","12":"eed5762c","13":"7ca1abae","14":"eb16817f","15":"42d682fb","16":"b40672bb","17":"7b05aef2","18":"0d31b04f","19":"0c7c6c5f","20":"680f2e87","21":"f633ddc1","22":"ed13bb03","23":"bd25acfd","24":"d3e192a3","25":"87f7e404","26":"19db82c1","27":"969f2214","28":"4d24c6ba","29":"49a027ae","30":"7de5b27f","31":"e4c3e80e","32":"632e016f","33":"8059659f","34":"ea3982ba","35":"14747ed7","36":"da87834a","37":"d27f9b9d","38":"7b8edc33","39":"796b314c","40":"23ae52df","41":"3ae6d921","42":"0df82df8","43":"5f3be393","44":"98ec574e","45":"bc2a90b0","46":"91fde84d","47":"c7b74d83","48":"0d6fad2a","49":"8c7cccf7","50":"3fbaac2b","51":"c7471805","52":"687d814d","53":"afadc84a","54":"587a0a2b","55":"743309ff","56":"4fbdbc49","57":"bf2d90bb","58":"146450fa","59":"0f004680","60":"2501d770","61":"622b0f1d","62":"ac7aedf8","63":"fa316479","64":"0ef3ba4c","65":"070ab509","66":"da3ad726","67":"005067c6","68":"223faa79","69":"b8dca2b4","70":"7b131c9b","71":"0df8bebc","72":"3d0a1d1d","73":"87742106","74":"1d2982de","75":"a4c7e07c","76":"aa521039","77":"dff3d2d1","78":"83e1278d","79":"139c938d","80":"3a0110fb","81":"afb27c0e","82":"25fb0abe","83":"a657fd62","84":"ac75f883","85":"8a6bc28f","86":"7eae79ea","87":"bb6f1c7a","88":"f8441de7","90":"13b4fc60","92":"d44c5476","93":"76845a67","94":"fd155a30","96":"8912ea7f","97":"a8526eb6","98":"7c70a587","99":"f2c36792","100":"58023536","101":"562121a0","102":"bdfb8e4c","103":"82d24b81","104":"fa2dfd0c","105":"9f315590","106":"d10ebe24","107":"197b7c01","108":"63b21d53","109":"e8a49061","110":"ec88dc24","111":"367514bf","112":"83622c8c","113":"16df8811","114":"0ae0c53d","115":"aad13c5c","116":"3d77d4a0","117":"f686bc57","118":"15128813","119":"1a21418a","120":"b2f5e574","121":"064062d8","122":"3d43ee34","123":"2f225171","124":"40bdf4a7","125":"6f74242e","126":"6b503b55","127":"434e8416","128":"c6ce6420","129":"86878976","130":"a6d50fce","131":"7826b29a","132":"e2efdb47","133":"721fd938","134":"afbb181a","135":"cd7a5615","136":"747e785f","137":"cfbbda95","138":"8b1912f1","139":"4cc5ab57","140":"3e0e666f","141":"85ac59ae","142":"b059f475","143":"cad6b0cd","144":"9c200e9f","145":"bfb404b9","146":"c46602c9","147":"7242235d","148":"aab81f1a","149":"fbeb6578","150":"3fe5fa0c","151":"0f861561","152":"5d39a022","153":"4b11cf73","154":"1d41d21a","155":"35431aa4","156":"6a332f1d","157":"2fc25513","158":"fbd1c864","159":"e252f040","160":"edbf3802","161":"3631da2b","162":"5ab6dcae","163":"eeac1611","164":"4f38849e","165":"4663b62b","166":"6c6f5a85","167":"840faf1a","168":"49317528","169":"523e6939","170":"e2393c4e","171":"224d3485","172":"1aaf32fc","173":"0286aa62","174":"a37b1211","175":"b8a4e41f","176":"af9ab4ad","177":"f41f1ee9"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"19":1,"21":1,"22":1,"23":1,"25":1,"28":1,"30":1,"31":1,"32":1,"33":1,"34":1,"37":1,"38":1,"40":1,"41":1,"43":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"57":1,"60":1,"65":1,"66":1,"68":1,"69":1,"70":1,"71":1,"72":1,"73":1,"75":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"90":1,"92":1,"93":1,"94":1,"97":1,"98":1,"100":1,"101":1,"102":1,"103":1,"104":1,"105":1,"106":1,"107":1,"108":1,"109":1,"112":1,"116":1,"120":1,"121":1,"125":1,"126":1,"130":1,"131":1,"132":1,"133":1,"134":1,"135":1,"136":1,"137":1,"138":1,"139":1,"140":1,"141":1,"142":1,"143":1,"155":1,"156":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"Debug","42":"EMAPortal","43":"EarlyProtect360Plus","44":"EarlyProtect360Plus.Dashboard","45":"EarlyProtect360Plus.Details","46":"FamilyProtect360","47":"FamilyProtectLiteWithUpgrade","48":"FilipinoBond","49":"FlashPayShieldWithUpgrade","50":"FraudProtect360","51":"HIProtect360Protect360","52":"HomeProtect360","53":"HomeProtectLite","54":"HomeSafe","55":"HomeStarterKit","56":"InternalDemoCookie","57":"KeymanProtect360","58":"KeymanProtect360.Dashboard","59":"KeymanProtect360.Details","60":"LeadForm","61":"Loan Protect 360 Renewal","62":"LoanProtect360","63":"LoanProtect360.Dashboard","64":"LoanProtect360.Details","65":"MaidProtect360","66":"MotoringCardShieldWithUpgrade","67":"Motorshow2020","68":"PartnerProgram","69":"PhoneProtect360","70":"PowerAgentPortal","71":"Prestige","72":"Prestige.Secured","73":"PublicHousingAssured","74":"ReviewUs","75":"SBSTPAProtectLite","76":"SBSTPAProtectPlus","77":"SBSTTravelInsurance","78":"SOA","79":"SimplyGo","80":"SingaporeTravelPass","81":"Touristcard","82":"TravelAssured","83":"TravelAssuredPlus","84":"TravelProtect360","85":"TravelProtect360Plus","86":"cileadform","87":"currencyconverter","88":"freehomeinsurance","90":"motorshow","92":"transferprotect360pro","93":"vCashCard","94":"weather"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"a858c2f5","20":"31d6cfe0","21":"a858c2f5","22":"86c9f98d","23":"d30bc41f","24":"31d6cfe0","25":"d33f62d9","26":"31d6cfe0","27":"31d6cfe0","28":"58058363","29":"31d6cfe0","30":"05f863ac","31":"ddf1f108","32":"04bc7233","33":"ddf1f108","34":"d33f62d9","35":"31d6cfe0","36":"31d6cfe0","37":"0e4fba13","38":"978e5247","39":"31d6cfe0","40":"ac3f861f","41":"5d27deaa","42":"31d6cfe0","43":"58058363","44":"31d6cfe0","45":"31d6cfe0","46":"ddf1f108","47":"0e4fba13","48":"ddf1f108","49":"0e4fba13","50":"ddf1f108","51":"ddf1f108","52":"471a3a57","53":"471a3a57","54":"471a3a57","55":"0e4fba13","56":"31d6cfe0","57":"58058363","58":"31d6cfe0","59":"31d6cfe0","60":"dd9a60e3","61":"31d6cfe0","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"14284125","66":"0e4fba13","67":"31d6cfe0","68":"8b647349","69":"471a3a57","70":"716aad65","71":"2fc531d7","72":"cdec5a50","73":"471a3a57","74":"31d6cfe0","75":"39dd3a27","76":"e81d10c5","77":"86c9f98d","78":"d33f62d9","79":"98c15efc","80":"2e8fdc12","81":"344cc04e","82":"86c9f98d","83":"86c9f98d","84":"2e8fdc12","85":"86c9f98d","86":"22b92479","87":"7b4f34de","88":"0e4fba13","90":"49234f01","92":"14284125","93":"94b03ce8","94":"23255cb6","96":"31d6cfe0","97":"cce35a68","98":"440606be","99":"31d6cfe0","100":"2d576837","101":"166c8acc","102":"db5d06da","103":"f93319e8","104":"f93319e8","105":"72c6f688","106":"72c6f688","107":"72c6f688","108":"f93319e8","109":"72c6f688","110":"31d6cfe0","111":"31d6cfe0","112":"6f6df1fe","113":"31d6cfe0","114":"31d6cfe0","115":"31d6cfe0","116":"6f6df1fe","117":"31d6cfe0","118":"31d6cfe0","119":"31d6cfe0","120":"6f6df1fe","121":"6f6df1fe","122":"31d6cfe0","123":"31d6cfe0","124":"31d6cfe0","125":"4b48318c","126":"4b48318c","127":"31d6cfe0","128":"31d6cfe0","129":"31d6cfe0","130":"4b48318c","131":"4b48318c","132":"4b48318c","133":"4b48318c","134":"4b48318c","135":"4b48318c","136":"4b48318c","137":"4b48318c","138":"4b48318c","139":"4b48318c","140":"4b48318c","141":"4b48318c","142":"4b48318c","143":"4b48318c","144":"31d6cfe0","145":"31d6cfe0","146":"31d6cfe0","147":"31d6cfe0","148":"31d6cfe0","149":"31d6cfe0","150":"31d6cfe0","151":"31d6cfe0","152":"31d6cfe0","153":"31d6cfe0","154":"31d6cfe0","155":"5fe6802c","156":"5fe6802c","157":"31d6cfe0","158":"31d6cfe0","159":"31d6cfe0","160":"31d6cfe0","161":"31d6cfe0","162":"31d6cfe0","163":"31d6cfe0","164":"31d6cfe0","165":"31d6cfe0","166":"31d6cfe0","167":"31d6cfe0","168":"31d6cfe0","169":"31d6cfe0","170":"31d6cfe0","171":"31d6cfe0","172":"31d6cfe0","173":"31d6cfe0","174":"31d6cfe0","175":"31d6cfe0","176":"31d6cfe0","177":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.hlas.com.sg/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonphlas-react-app"] = this["webpackJsonphlas-react-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
